import { gql } from '@apollo/client';
import { goalFragment } from '../fragments/goal';

export const getGoalsQuery = gql`
    ${goalFragment}

    query GetGoals {
        goals {
            ...GoalFields
        }
    }
`;
